export default __webpack_public_path__ + "static/media/sommlike-icon.033873f2.png";